export const lineDateSortOptions = [
    { value: 'today', label: 'Сегодня' },
    { value: 'yesterday', label: 'Вчера' },
    { value: 'week', label: 'Неделя' },
    { value: 'month', label: 'Месяц' },
    { value: 'quarter', label: 'Квартал' },
    { value: 'year', label: 'Год' },
] as const
export type LineDateSortType = (typeof lineDateSortOptions)[number]['value']
export interface LineDateSortOptionType {
    value: LineDateSortType
    label: string
}
export const typedLineDateSortOptions: readonly LineDateSortOptionType[] =
    lineDateSortOptions
export const trafficSourceSortOptions = [
    { value: 'inviteLinks', label: 'инвайт ссылки' },
    { value: 'anySource', label: 'без разметки' },
    { value: 'allTraffic', label: 'весь трафик' },
] as const
export type TrafficSourceType =
    (typeof trafficSourceSortOptions)[number]['value']
export interface TrafficSourceOptionType {
    value: TrafficSourceType
    label: string
}
export const typedTrafficSourceSortOptions: readonly TrafficSourceOptionType[] =
    trafficSourceSortOptions

export const detalizationSortOptions = [
    { value: 'daily', label: 'по дням' },
    { value: 'weekly', label: 'по неделям' },
    { value: 'monthly', label: 'по месяцам' },
] as const
export type DetalizationType = (typeof detalizationSortOptions)[number]['value']
export interface DetalizationOptionType {
    value: DetalizationType
    label: string
}
export const typedDetalizationSortOptions: readonly DetalizationOptionType[] =
    detalizationSortOptions

export const usersSortOptions = [
    { value: 'allUsers', label: 'Все пользователи' },
    { value: 'premiumUsers', label: 'Только Premium' },
    { value: 'noPremium', label: 'Без Учета Premium' },
] as const
export const subscriberStatusSortOptions = [
    { value: 'all', label: 'все' },
    { value: 'subscribed', label: 'подписки' },
    { value: 'unsubscribed', label: 'отписки' },
] as const
export type UsersSortType = (typeof usersSortOptions)[number]['value']
export type SubscriberStatusSortType =
    (typeof subscriberStatusSortOptions)[number]['value']

export interface UsersSortOptionType {
    value: UsersSortType
    label: string
}
export interface SubscriberStatusSortOptionType {
    value: SubscriberStatusSortType
    label: string
}
export const typedUsersSortOptions: readonly UsersSortOptionType[] =
    usersSortOptions
export const typedSubscriberStatusSortOptions: readonly SubscriberStatusSortOptionType[] =
    subscriberStatusSortOptions

export const gmtOptions = [
    { value: 'Etc/GMT-1', label: 'GMT +1' },
    { value: 'Etc/GMT-2', label: 'GMT +2' },
    { value: 'Etc/GMT-3', label: 'GMT +3' },
    { value: 'Etc/GMT-4', label: 'GMT +4' },
    { value: 'Etc/GMT-5', label: 'GMT +5' },
    { value: 'Etc/GMT-6', label: 'GMT +6' },
    { value: 'Etc/GMT-7', label: 'GMT +7' },
    { value: 'Etc/GMT-8', label: 'GMT +8' },
    { value: 'Etc/GMT-9', label: 'GMT +9' },
    { value: 'Etc/GMT-10', label: 'GMT +10' },
] as const
export type GmtType = (typeof gmtOptions)[number]['value']
export interface GmtOptionType {
    value: GmtType
    label: string
}
